import { inject, Injectable, signal, Signal, TemplateRef } from '@angular/core';
import { BrnDialogRef, BrnDialogService } from '@spartan-ng/brain/dialog';
import { AlertButtons } from '../components/global/alert/alert.component';
import { ComponentType } from '@angular/cdk/overlay';

@Injectable({ providedIn: 'root' })
export class AlertDialogService {
  
  private dialogRef!: BrnDialogRef<unknown> | undefined;
  private dialogService = inject(BrnDialogService);

  open(header: string, description: string | Signal<string>, buttons: AlertButtons[], isXIconVisible = true, component: ComponentType<unknown> | TemplateRef<unknown>, action? : string): Promise<boolean> {
    if (this.dialogRef) this.dialogRef.close();
    if (!buttons || buttons.length === 0) {
      buttons = [
        {
          id: 'btn-alert-ok',
          text: 'OK',
          type: 'action',
          action: () => this.close(),
        },
      ];
    }
    
    const processedButtons = buttons.map((btn) => ({
      ...btn,
      action: (...args: unknown[]) => {
        btn.action?.(...args);
        this.dialogRef?.close(args[0]);
      },
    }));

    this.dialogRef = this.dialogService.open(component, undefined, {
      data: {
        header,
        description: typeof description === 'function' ? description : signal(description),
        buttons: processedButtons,
        isXIconVisible,
        action
      },
    });

    return new Promise((resolve) => {
      this.dialogRef?.closed$.subscribe((result: unknown) => {
        resolve((result as boolean) ?? false);
      });
    });
     
  }

  close() {
    this.dialogRef?.close();
    this.dialogRef = undefined;
  }

  isOpen(): boolean {
    return Boolean(this.dialogRef);
  }
}
